<template>
  <div>
    <div>
      <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            :style="{
              'background-image': 'url(\'/static/img/' + tool.image + '\')',
              'background-position': tool.backgroundPosition + ' !important',
            }"
          ></div>
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t(tool.designation) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Breadcrumb />
    <div>
      <div class="row align-items-start toolDetailsPg toolDetailsPgNewWrap">
        <!-- Left Area -->
        <div class="col-xl-9 pl-16 pt-0">
          <div class="mx-0 pa-0 text-content">
            <h4>{{ $t(tool.goal_headline) }}</h4>
            <p v-html="this.$t(tool.goal)"></p>
            <div class="mt-10"></div>
          </div>

          <div class="mt-14 mx-0 pa-0 text-content">
            <h4 v-show="this.$t(tool.usage) != '' && isTools">
              {{ $t("usage") }}
            </h4>
            <p
              v-show="this.$t(tool.usage) != ''"
              v-html="this.$t(tool.usage)"
            ></p>
            <div v-show="this.$t(tool.usage) != ''" class="mt-10"></div>
          </div>
        </div>
        <!-- Right Area -->
        <div class="col-xl-3 pl-8 pt-0">
          <div class="col-xl-12 right-side-block">
            <h4 class="text-uppercase hide">{{ $t("actions") }}</h4>
            <div class="mt-6 hide"></div>
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <div class="right-side divider hide"></div>
            <div class="mt-6 hide"></div>
            <h4 class="open-training-title">{{ $t("openTraining") }}</h4>
            <div class="right-side divider mb-5"></div>
            <div v-if="uniqueTrainings.length > 0" class="mt-6">
              <div
                v-for="(training, index) in uniqueTrainings.slice(0, 5)"
                :key="index"
                class="mb-2 sessionLink"
              >
                <a :href="'/request?trainingId=' + training.value">{{
                  training.text
                }}</a>
              </div>
              <a class="view-all-traning-link" href="/trainings">
                {{ $t("openTrainingSessions") }}
                <svg
                  class="arrow-svg arrow-svg-1"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.52034 1.95953C8.22734 3.43106 8.64034 5.15875 8.64034 6.98291V7.00063V6.99975V7.01638C8.64034 8.84075 8.22734 10.5682 7.48971 12.1111L7.52034 12.0398H5.07077C5.95605 10.6078 6.48084 8.87159 6.48084 7.01288V6.99909V6.99975V6.97503C6.48372 5.18956 5.98957 3.43852 5.05371 1.91797L5.07777 1.95997L7.52034 1.95953Z"
                    fill="#00457E"
                  />
                  <path
                    d="M9.35851 6.99875V6.97884C9.35851 5.16278 8.97263 3.43728 8.27832 1.87891L8.31004 1.95875H10.4739L12.9244 6.98081L10.4739 12.0387H8.31004C8.97263 10.5602 9.35829 8.8345 9.35829 7.01844V6.99766V6.99853L9.35851 6.99875Z"
                    fill="#00457E"
                  />
                </svg>
              </a>
            </div>
            <div class="mt-6" v-else>{{ $t("noOpenTrainings") }}</div>
          </div>
          <Contact />
        </div>
      </div>

      <!-- Tools -->
      <div v-show="isTools" class="row moretools">
        <div class="vf_offer">
          <h4 class="pl-12 pl-md-16 col-12 pb-0 mb-0 pr-4 text-uppercase">
            {{ $t("further_tools") }}
          </h4>
          <div class="divider"></div>
        </div>
        <div
          v-show="toolName != tool.url"
          class="tool mx-0 col-xl-4 col-md-6"
          v-for="tool in tools"
          :key="tool.id"
        >
          <div class="category-box">
            <v-card
              flat
              class="no-border-radius sixteentonine"
              height="100%"
              :href="'/tools/' + tool.url"
            >
              <v-img
                class="kachelimage"
                height="100%"
                :src="`/static/img/${tool.image}`"
              ></v-img>
              <div class="pl-md-12 pl-8 py-1 bottom-row bg-blue">
                {{ $t(tool.designation) }}
              </div>
            </v-card>
          </div>
        </div>
        <div class="mt-10"></div>
      </div>

      <!-- Offer -->
      <div v-show="isOffers" class="row">
        <div class="vf_offer">
          <h4 class="pl-12 pl-md-16 col-12 pb-0 mb-0 pr-4 text-uppercase">
            {{ $t("further_offers") }}
          </h4>
          <div class="divider"></div>
        </div>
        <div
          v-show="toolName == offer.url"
          class="mx-0 col-xl-4 col-md-6"
          v-for="offer in offers"
          :key="offer.url"
        >
          <div class="category-box">
            <v-card
              flat
              class="no-border-radius sixteentonine"
              height="100%"
              :href="'/offers/' + offer.url"
            >
              <v-img
                class="kachelimage"
                height="100%"
                :src="`/static/img/${offer.image}`"
              ></v-img>
              <div class="pl-md-12 pl-8 py-1 bottom-row bg-blue">
                {{ $t(offer.designation) }}
              </div>
            </v-card>
          </div>

          <br />
          <br />
          <br />
        </div>

        <div class="mt-10"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  props: {},

  data() {
    return {
      trainings: [],
      isOffers: null,
      offers1: [
        { url: "producttraining", image: "producttraining_header.jpg" },
        { url: "hydraulic", image: "hydraulic_header.jpg" },
        { url: "pressure", image: "pressure_header-1.jpg" },
      ],
      isTools: null,
      tool1: [
        { url: "practical", image: "practicaltrainingnewheader-1.png" },
        { url: "technical", image: "technicalcoachingnewheader-1.jpg" },
        { url: "virtualclassroom", image: "virtualclassroomnewheader-1.jpg" },
        { url: "advisory", image: "advisorynewheader-1.jpg" },
        { url: "theory", image: "theory_header-1.jpg" },
        { url: "virtualreality", image: "virtualreality_header-1.jpg" },
      ],

      tool: null,
      toolName: null,
      tools: {
        practical: {
          url: "practical",
          designation: "practical training",
          goal_headline: "goal_headline_practical_training",
          goal: "practical_goal",
          usage: "practical_usage",
          image: "practicaltrainingnewheader-1.png",
          backgroundPosition: "top",
        },
        technical: {
          url: "technical",
          designation: "technical coaching",
          goal_headline: "goal_headline_technical_coaching",
          goal: "technical_goal",
          usage: "technical_usage",
          image: "technicalcoachingnewheader-1.jpg",
          backgroundPosition: "center",
        },
        virtualclassroom: {
          url: "virtualclassroom",
          designation: "virtual classroom",
          goal_headline: "goal_headline_virtual_classroom",
          goal: "virtualclassroom_goal",
          usage: "virtualclassroom_usage",
          image: "virtualclassroomnewheader-1.jpg",
          backgroundPosition: "center",
        },
        theory: {
          url: "theory",
          designation: "theory training",
          goal_headline: "goal_headline_theory_training",
          goal: "theory_goal",
          usage: "theory_usage",
          image: "theory_header-1.jpg",
          backgroundPosition: "top",
        },
        advisory: {
          url: "advisory",
          designation: "advisory",
          goal_headline: "goal_headline_advisory",
          goal: "advisory_goal",
          usage: "advisory_usage",
          image: "advisorynewheader.jpg",
          backgroundPosition: "center",
        },
        virtualreality: {
          url: "virtualreality",
          designation: "virtual reality",
          goal_headline: "goal_headline_virtual_reality",
          goal: "virtualreality_goal",
          usage: "virtualreality_usage",
          image: "virtualreality_header-1.jpg",
          backgroundPosition: "center",
        },
      },

      offers: {
        producttraining: {
          url: "producttraining",
          designation: "producttraining",
          goal_headline: "goal_headline_product_training",
          goal: "producttraining_goal",
          usage: "producttraining_usage",
          image: "producttraining_header.jpg",
          backgroundPosition: "center",
        },
        hydraulic: {
          url: "hydraulic",
          designation: "hydraulic",
          goal_headline: "goal_headline_hydraulic",
          goal: "hydraulic_goal",
          usage: "hydraulic_usage",
          image: "hydraulic_header.jpg",
          backgroundPosition: "center",
        },
        pressure: {
          url: "pressure",
          designation: "pressure",
          goal_headline: "goal_headline_pressure",
          goal: "pressure_goal",
          usage: "pressure_usage",
          image: "pressure_header-1.jpg",
          backgroundPosition: "top",
        },
      },
    };
  },

  computed: {
      uniqueTrainings() {
            const seen = new Set();

    return this.trainings
      .filter(training => training.designationsMap && training.designationsMap[this.$locale])
       .filter(training => {
        if (seen.has(training.id)) return false;
        seen.add(training.id);
        return true;
      })
      .map(training => ({
        text: training.designationsMap[this.$locale],
        value: training.id,
        isPopular: training.isPopular,
      }));
  },

    // uniqueTrainings() {
    //   return Array.from(
    //     new Set(this.trainings.map((training) => training.value))
    //   ).map((value) => {
    //     return this.trainings.find((training) => training.value === value);
    //   });
    // },
  },

  watch: {
    tool(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchTrainings();
    this.toolName = window.location.href.substring(
      window.location.href.lastIndexOf("/") + 1
    );
    if (this.toolName.includes("?")) {
      this.toolName = this.toolName.substring(0, this.toolName.indexOf("?"));
    }
    if (window.location.href.includes("tools")) {
      this.tool = this.tools[this.toolName];
      this.isTools = true;
    } else if (window.location.href.includes("offers")) {
      this.tool = this.offers[this.toolName];
      this.isOffers = true;
    }
  },

  methods: {
    fetchTrainings() {
      var _this = this;
      this.$axios
        .get("/api/training/opentrainings")
        .then(function (response) {
         _this.trainings = response.data;
          // for (let i = 0; i < trainings.length; i++) {
          //   const training = trainings[i];
          //   _this.trainings.push({
          //     text: training.designationsMap[_this.$locale],
          //     value: training.id,
          //     isPopular: training.isPopular,
          //   });
          // }
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchSelectedVenue() {
      var _this = this;

      this.$axios
        .get("/api/location/" + this.venueId)
        .then(function (response) {
          _this.venue = response.data;
        })
        .catch(this.onError);
    },
  },
};
</script>
